import {
  BrowserHistory,
  createBrowserHistory,
  createMemoryHistory,
  MemoryHistory,
} from 'history'
import {
  TypedUseSelectorHook,
  useDispatch as defaultUseDispatch,
  useSelector as defaultUseSelector,
} from 'react-redux'

import { type DispatchFunc, type State } from 'domains/application/store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch: DispatchFunc = defaultUseDispatch
export const useSelector: TypedUseSelectorHook<State> = defaultUseSelector
export let history: ReturnType<typeof createBrowserHistory> | null = null
export type AppHistory = BrowserHistory | MemoryHistory

// TODO: dep injection with configs
history =
  typeof window === 'undefined' ? createMemoryHistory() : createBrowserHistory()

if (typeof window !== 'undefined') {
  window.__HISTORY__ = history
}

export function getHistory() {
  return history as AppHistory
}

export function useHistory() {
  const canGoBack = useSelector((state) => state.application.canGoBack)
  return {
    ...(history as AppHistory),
    push(url: string, state = 'NOT_FIRST_ROUTE') {
      history?.push(url, state)
      // window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    backOrPush(url: string, state = 'NOT_FIRST_ROUTE') {
      if (canGoBack) {
        history?.back()
      } else {
        history?.push(url, state)
      }
      // window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  }
}
